import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'alert-window',
  templateUrl: './alert-window.component.html',
  styleUrls: ['./alert-window.component.css']
})
export class AlertWindowComponent implements OnInit {

  @HostBinding("style.z-index") zIndex:string;
  @HostBinding("style.top") styleTop:string;
  
  visible:boolean = false;

  @Input()
  top:string;

  @Input()
  width:string = "50px";

  @Input()
  title:string;

  @Input()
  msg:string;

  @Input()
  values:Array<string>;

  @Input()
  functions:Array<Function>

  constructor() { }

  ngOnInit() {
    this.styleTop = this.top;
  }

  callFunction(value:string):void{
    let i:number = 0;
    for(; this.values[i] != value; i++){
    }

    let f:Function = this.functions[i];
    let result:boolean = f.call(this);
    if(result){
      this.hideWindow();
    }
  }

  isVisible():boolean{
    return this.visible;
  }
  showWindow():void{
    this.visible = true;
    this.zIndex = "520";
  }
  showWindowWithParams( windowParams:any ):void{
    this.showWindow();
    if( windowParams != null && windowParams[ 2 ] == 'title'){
      this.title = windowParams[ 3 ];
    }
    if( windowParams != null && windowParams[ 4 ] == 'msg'){
      this.msg = windowParams[ 5 ];
    }
  }
  hideWindow():void{
    this.visible = false;
    this.zIndex = "-100";
  }
}
